import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
function getTargetDate(): Date {
  const STORAGE_KEY = 'promo_end_date';
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored) {
    const date = new Date(stored);
    if (date.getTime() > Date.now()) {
      return date;
    }
  }
  // Set 2 days from now
  const target = new Date(Date.now() + 2 * 24 * 60 * 60 * 1000);
  localStorage.setItem(STORAGE_KEY, target.toISOString());
  return target;
}
function calculateTimeLeft(target: Date) {
  const diff = target.getTime() - Date.now();
  if (diff <= 0) return {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  };
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor(diff / (1000 * 60 * 60) % 24),
    minutes: Math.floor(diff / (1000 * 60) % 60),
    seconds: Math.floor(diff / 1000 % 60)
  };
}
function TimeBlock({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-318">
      <div className="bg-navy font-serif font-bold text-gold text-xl md:text-3xl w-12 h-12 md:w-16 md:h-16 rounded-lg md:rounded-xl flex items-center justify-center shadow-inner" data-id="element-319">
        {String(value).padStart(2, '0')}
      </div>
      <span className="text-[10px] md:text-xs text-white/40 mt-1 uppercase tracking-wider font-sans" data-id="element-320">
        {label}
      </span>
    </div>;
}
export function CountdownTimer() {
  const [target] = useState(getTargetDate);
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(target));
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft(target));
    }, 1000);
    return () => clearInterval(interval);
  }, [target]);
  const isExpired = timeLeft.days === 0 && timeLeft.hours === 0 && timeLeft.minutes === 0 && timeLeft.seconds === 0;
  if (isExpired) return null;
  return <div className="flex flex-col items-center gap-3" data-id="element-321">
      <div className="flex items-center gap-1.5 text-gold" data-id="element-322">
        <ClockIcon className="w-4 h-4" data-id="element-323" />
        <span className="text-xs md:text-sm font-bold uppercase tracking-wider" data-id="element-324">
          La oferta termina en
        </span>
      </div>
      <div className="flex items-center gap-2 md:gap-3" data-id="element-325">
        <TimeBlock value={timeLeft.days} label="Días" data-id="element-326" />
        <span className="text-gold font-bold text-xl md:text-2xl -mt-4" data-id="element-327">:</span>
        <TimeBlock value={timeLeft.hours} label="Horas" data-id="element-328" />
        <span className="text-gold font-bold text-xl md:text-2xl -mt-4" data-id="element-329">:</span>
        <TimeBlock value={timeLeft.minutes} label="Min" data-id="element-330" />
        <span className="text-gold font-bold text-xl md:text-2xl -mt-4" data-id="element-331">:</span>
        <TimeBlock value={timeLeft.seconds} label="Seg" data-id="element-332" />
      </div>
    </div>;
}